import { composeUrl, type OptionalQueryParams, type QueryParams } from '@lib/utils/url'

import { IS_BROWSER } from '@constants/globals'

export class NavigationService {
  private readonly serverQueryParams?: Record<string, string | string[] | undefined>

  constructor(serverQueryParams?: Record<string, string | string[] | undefined>) {
    this.serverQueryParams = serverQueryParams
  }

  /**
   * Get current query parameters.
   * On server-side, uses provided query params from SSR context.
   * On client-side, reads directly from window.location.
   */
  get currentQueryParams(): QueryParams {
    if (!IS_BROWSER) {
      // Server-side: use provided query params
      if (this.serverQueryParams) {
        return Object.entries(this.serverQueryParams).reduce((acc, [key, value]) => {
          // Handle both string and string[] values from Next.js context.query
          acc[key] = Array.isArray(value) ? value[0] || '' : value || ''
          return acc
        }, {} as QueryParams)
      }
      return {}
    }

    // Client-side: read from window.location
    const urlObject = new URL(window.location.href)
    return [...urlObject.searchParams.entries()].reduce((acc, [key, value]) => {
      acc[key] = value
      return acc
    }, {} as QueryParams)
  }

  readonly navigateUrl = (url: string, queryParams: OptionalQueryParams = {}) => {
    return this.navigate(composeUrl(url, queryParams))
  }

  private readonly navigate = (fullUrl: string) => {
    if (IS_BROWSER) {
      window.location.assign(fullUrl)
    }
  }
}
